import { Component, OnInit } from '@angular/core';
import { AppDataServiceService } from 'src/app/app-data-service.service';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import {NgbDateStruct, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';
//import { LeftAsideComponent } from 'src/app/leftAside/leftAside.component';
//mport { LeftAsideComponent } from 'src/app/leftAside/leftAside.component';


@Component({
  selector: 'app-all-device-greaph',
  templateUrl: './all-device-greaph.component.html',
  styleUrls: ['./all-device-greaph.component.css']
})
export class AllDeviceGreaphComponent implements OnInit {
   model: NgbDateStruct;
   public newDate:string;
   public newDates:string;
  //getdate: void;
 
  selectToday() {
    //this.model = this.calendar.getToday();
      this.newDates = this.model.year +"-"+(this.model.month)+"-"+this.model.day  ; 
      this._networkService.getDeviceData( this.selectedDevice,this.newDates,this.selectedParameter).subscribe(
      data => this.makelinechartData(data),
     //console.log(data);
      error => console.log(error),

    );
  }
  constructor(
    private _networkService:AppDataServiceService,
    private calendar: NgbCalendar,
    private dates:AppDataServiceService,
     //private dates:LeftAsideComponent
    ) {         
          }

  ngOnInit() {
      this.dates.getdate.subscribe(newDate=>this.newDate = newDate);
      let date = new Date(this.newDate);
      this.model = {day:date.getDate(),month:date.getMonth()+1,year:date.getFullYear()}
      console.log('hi1123');
      return this._networkService.getAllDeviceDetails().subscribe(
      data => this.setSelecteMenu(data),
      error => console.log(error),

    );
    
   // console.log(this.dates.getdate.subscribe(newDate=>this.newDate = newDate));
 
  }

  selectedDevice:any;
  selectedParameter:any;
  selectedDeviceText:any;
  selectedParameterText:any;
  filtered :any;

  device_list = { name: "notloaded", device_id: "0" };
  parameter_list = { name: "notloaded", value: "0" };

  
  
    onDeviceSelected(event: Event) {
      let selectElementText = event.target['options']
         [event.target['options'].selectedIndex].text;
      this.selectedDeviceText = selectElementText
         console.log(selectElementText);                                 
   }



  onParameterSelected(event: Event) {
    
    let selectElementText = event.target['options']
         [event.target['options'].selectedIndex].text;
    this.selectedParameterText= selectElementText
  }
  setSelecteMenu(data) {
    this.device_list = data.data.device_detail;
    this.parameter_list = data.data.parameter_details;
   // this.makelinechart(); 
  }
  makelinechartData(data){
    this.makelinechart(data['data']);
  }
makelinechart(data){
  console.log("hllo");
  let chart = am4core.create("chart", am4charts.XYChart);  
    chart.data = data;

    let title = chart.titles.create();
    title.text = `${this.selectedParameterText} of ${this.selectedDeviceText} for  date : ${data[0].dt_time} `;
    title.fontSize = 14;
    title.marginBottom = 10;

  // Create axes
  let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
  //dateAxis.renderer.minGridDistance = 60;
  chart.dateFormatter.inputDateFormat = "HH:mm, d MMMM"
  let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

  // Create series
  let series = chart.series.push(new am4charts.LineSeries());
  series.dataFields.valueY = "value";
  series.dataFields.dateX = "dt_time";
  series.tooltipText = "{value}";
  series.strokeWidth = 3;

 
  series.tooltip.pointerOrientation = "vertical";

  chart.cursor = new am4charts.XYCursor();
  chart.cursor.snapToSeries = series;
  chart.cursor.xAxis = dateAxis;
}

}
